import React from "react";
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import {
  Runner_runner$key,
  RunnerStatus,
} from "./__generated__/Runner_runner.graphql";
import _ from "lodash";
import { purple } from "@mui/material/colors";

interface RunnerProps {
  runner: Runner_runner$key;
}

function Runner(props: RunnerProps) {
  const theme = useTheme();

  let runner = useFragment(
    graphql`
      fragment Runner_runner on Runner {
        id
        status
        slots
        organizationName
        vmInfo {
          image
        }
        assignedGitHubJob {
          jobId
          owner
          repository
          name
          status
          conclusion
          externalUrl
          createdAt
          startedAt
          completedAt
        }
      }
    `,
    props.runner,
  );

  let job = runner.assignedGitHubJob;

  function runnerStatusColor(status: RunnerStatus) {
    switch (status) {
      case "IDLE":
        return theme.palette.info.light;
      case "SHARED":
        return purple[300];
      case "PREPARING":
        return theme.palette.info.main;
      case "RUNNING":
        return theme.palette.success.light;
    }
    return theme.palette.error.main;
  }

  if (runner.status === "IDLE") {
    return null;
  }

  let displayStatus = _.capitalize(runner.status.toLowerCase());

  let runnerDescription = "Awaiting job assigment...";
  let runnerHint = runner.vmInfo?.image;
  if (job != null) {
    runnerDescription = `${displayStatus} "${job.name}" job in ${job.repository} repository`;
  } else if (runner.status === "SHARED") {
    runnerDescription = `Task that uses ${runner.slots} runner ${runner.slots === 1 ? "slot" : "slots"}`;
    runnerHint = `Running in ${runner.organizationName} organization`;
  }
  return (
    <ListItem
      disableGutters
      key={runner.id}
      secondaryAction={
        runner.status !== "SHARED" && (
          <IconButton
            edge="end"
            aria-label="delete"
            onClick={() => window.open(job?.externalUrl, "_blank")}
          >
            <OpenInNewIcon />
          </IconButton>
        )
      }
    >
      <ListItemIcon>
        <Avatar sx={{ bgcolor: runnerStatusColor(runner.status) }}>
          <AppleIcon />
        </Avatar>
      </ListItemIcon>
      <ListItemText primary={runnerDescription} secondary={runnerHint} />
    </ListItem>
  );
}

export default Runner;
